import { ContactInformation } from "PFApp/components/contact_information";
import { useProfilePreviewData } from "PFApp/use_profile_preview";
import { useTranslation } from "react-i18next";

import { ProfilePreviewHeader } from "./profile_preview_header";

export const ProfilePreviewContact = () => {
  const { t } = useTranslation("core");

  const {
    data: { profile }
  } = useProfilePreviewData();

  if (!profile) {
    return null;
  }

  return (
    <section data-qa-id="ProfilePreviewContact">
      <ProfilePreviewHeader>{t("profilePreview.contact")}</ProfilePreviewHeader>
      <ContactInformation profile={profile} showLabels />
    </section>
  );
};
